export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'eu', label: 'Euskara' },
];

export const APP_LOCALES = LANGUAGES.map((lang) => lang.code);
